import {Box, Link, Typography} from '@mui/material';
import {SITE_TITLE, SITE_URL} from '../../constants';

export default function FooterCopyright() {
  return (
    <Box mt={5}>
      <Typography variant="body2" color="text.secondary" align="center">
        {'Copyright © '}
        <Link color="inherit" href={SITE_URL}>
          {SITE_TITLE}
        </Link>{' '}
        {new Date().getFullYear()}.
      </Typography>
    </Box>
  );
}
